export const URL_LOGO_ADMIN = 'https://min.gamelearn.io/css-resources/gamelearn/resources/campus/lms.svg';
export const URL_LOGO_CAMPUS = 'https://min.gamelearn.io/css-resources/gamelearn/resources/campus/campus.svg';
export const URL_LOGO_EDITOR = 'https://min.gamelearn.io/css-resources/gamelearn/resources/campus/editor.svg';
export const DEFAULT_CHART_WIDTH = 152;
export const DEFAULT_CHART_HEIGHT = 152;
export const NO_EDITOR_PLAN: string = 'no-editor';
export const DEFAULT_CONFIG_FORM = {
  hideSubmit: false,
  submitLabel: 'actions.save',
  showSpinnerUponSubmitting: true,
  disableCard: false,
  enableGridColCard: false,
  enableFullWidthForm: false,
  isDirtySubmit: false
};
